// extracted by mini-css-extract-plugin
export default {"hsOnboardingLayout":"OnboardingLayout_hsOnboardingLayout__0ngYA","hsOnboardingLayoutContent":"OnboardingLayout_hsOnboardingLayoutContent__f9O7V"};